module.exports = __webpack_public_path__ + "img/Medieval_Sword_Rapier.454441c3.png";